import { createContext } from 'react';
import type { Context } from 'react';
import type { RouteComponentProps } from '.';

const createNamedContext = (name: string) => {
  const context = createContext<RouteComponentProps | null>(
    null
  ) as Context<RouteComponentProps>;
  context.displayName = name;
  return context;
};

const context = /*#__PURE__*/ createNamedContext('Router');
export default context;
